<template>
    <div class="activities">


        <div class="title">
            <div></div>
            推送列表
        </div>
        <div class="query">

            <div class="query-box">

                <el-select v-model="queryForm.isResult" placeholder="是否推送成功">
                    <el-option label="全部" value="">全部</el-option>
                    <el-option label="推送成功" :value="true">推送成功</el-option>
                    <el-option label="推送失败" :value="false">推送失败</el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="inquire">查询</el-button>
        </div>
        <div class="activities-main">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column align="center" type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column align="center" prop="headImages" label="头像">
                    <template slot-scope="images">
                        <el-image style="width: 50px; height: 50px" class="table-td-thumb" :src="images.row.headImage"
                            :preview-src-list="[images.row.headImage]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="nickName" label="用户昵称">
                </el-table-column>

                <el-table-column align="center" prop="isVip" label="会员状态">
                    <template slot-scope="scope">
                        <div :class="scope.row.isVip == true ? 'active2' : 'active'">
                            {{ scope.row.isVip == true ? '会员' : "非会员" }}
                        </div>


                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否推送成功">
                    <template slot-scope="scope">
                        {{ scope.row.isResult ? '是' : '否' }}
                    </template>


                </el-table-column>

            </el-table>
            <!-- 分页 -->
            <div class="paging">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="queryForm.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="queryForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>


    </div>
</template>
  
<script>
import { pushList } from "@/api/api";
export default {
    data() {
        return {

            total: 0,
            tableData: [],


            queryForm: {
                id: '',
                isResult: '',
                pageNum: 1,
                pageSize: 10,
            },



        };
    },
    created() {

        this.queryForm.id = this.$route.query.id
        this.getList()

    },
    methods: {
        getList() {
            pushList(this.queryForm).then(res => {
                console.log(res)
                this.tableData = res.data.list
                this.total = res.data.total
            })
        },
        inquire() {
            this.getList()
        },


        //每页多少条
        handleSizeChange(val) {
            this.queryForm.pageSize = val;
            this.getList();
        },
        //当前多少页
        handleCurrentChange(val) {
            this.queryForm.pageNum = val;
            this.getList();
        },

    },
};
</script>
  
<style lang="less" scoped>
.activities {
    // height: 100%;
    background: #fff;
    padding: 15px;
    color: #303133;

    .title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;

        div {
            width: 3px;
            height: 16px;
            background: #409eff;
            margin-right: 10px;
        }
    }

    .query {
        margin: 15px 0 30px;
        display: flex;
        align-items: center;

        .query-box {
            display: flex;
            align-items: center;
            margin-right: 20px;

            .el-input {
                width: 260px;
            }

            span {
                width: 60px;
            }
        }
    }

    .activities-main {
        margin: 15px 0;
    }

    .paging {
        display: flex;
        justify-content: flex-end;
    }
}

.active {
    color: #33b959;
}
</style>